import { render } from "./App.vue?vue&type=template&id=dbfc9dfa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dbfc9dfa&lang=css"

import exportComponent from "/opt/python_pjs/Django_test/vue_project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__